<template lang='pug'>
.short-text.box(
	:class='{ focus, "has-sub-title" : options.subTitle, "has-value" : localValue !== "", error : hasErrors }'
	@click='focusInput'
)
	.label(
		:class='{ error : hasErrors }'
		v-if='options.label'
	) {{ options.label }}
		span.error(v-if='hasErrors') {{ localError }}
	.minimal-label.highlight-text(
		v-if='options.minimalLabel'
		:class='{ visible : localValue !== "" || hasErrors }'
	)
		| {{ options.minimalLabel }}
		span.error(v-if='hasErrors && !options.label')  - {{ localError }}
	.input-wrapper
		.before-character(v-if='options.beforeCharacter' v-show='localValue') {{ options.beforeCharacter }}
		input(
			:class='{ "highlight-text" : !options.minimalLabel }'
			v-model='localValue'
			ref='input'
			:placeholder='( state === "loaded" || state === "failed" )  ? options.placeholder : ( options.loadingPlaceholder || "Loading..." )'
			@focus='focusAndSelectIfNecessary'
			@blur='focus = false'
			@keydown='shouldBeComputed = false'
		)
		span.load-icon(v-if='state === "failed"' @click='init')
			svg(
				xmlns='http://www.w3.org/2000/svg'
				version='1.1'
				width='512'
				height='512'
				viewBox='0 0 512 512'
			)
				title
				g#icomoon-ignore
				path(
				d='M444.84 83.16c-46.804-51.108-114.077-83.16-188.84-83.16-141.385 0-256 114.615-256 256h48c0-114.875 93.125-208 208-208 61.51 0 116.771 26.709 154.848 69.153l-74.848 74.847h176v-176l-67.16 67.16z'
				)
				path(
					d='M464 256c0 114.875-93.125 208-208 208-61.51 0-116.771-26.709-154.847-69.153l74.847-74.847h-176v176l67.16-67.16c46.804 51.108 114.077 83.16 188.84 83.16 141.385 0 256-114.615 256-256h-48z'
				)
	.sub-title(
		v-if='options.subTitle'
	) {{ options.subTitle }}
</template>

<script>
export default {
	name : 'short-text',

	props : {
		options : {
			type : Object
		},

		value : {
			type : [String, Number],
		},

		errors : {
			type : [Object, String, Boolean],
		},

		formValue : {
			type : Object,
		},

		field : {
			type : Object,
		},

		form : {
			type : Object,
		},

		focusFromParent : {
			type : Boolean,
		}
	},

	data : () => ( {
		localValue : '',
		focus      : false,

		state : 'loaded',

		localError : '',

		shouldBeComputed : false,
	} ),

	computed : {

		hasErrors() {
			// // ! (= false)     true                 &&         false        false
			// + (= 'string')  true                 &&         true         true
			// + (= '')        true                 &&         false        false
			// + (= true)      false                &&         true         false
			// + (= {})        true                 &&         false        false
			// + (= [])        true                 &&         false        false
			return ( this.localError !== true ) && ( typeof this.localError !== 'object' && !!this.localError );
		},

	},

	created() {
		this.localValue       = this.value;
		this.shouldBeComputed = this.options.computedValue !== undefined;

		if ( this.options.prefill && !this.value ) {
			this.state = 'loading';

			this.init();

		}
	},

	watch : {
		localValue( value ) {
			this.$emit( 'input', value );

			// clear any error if there
			this.localError = '';
		},

		value( value ) {
			if ( value !== this.localValue ) {
				this.localValue = value;
			}

			if ( typeof this.localValue === 'number' ) {
				this.localValue = this.localValue.toString();
			}
		},

		errors : {
			immediate : true,
			handler( errors ) {
				if ( typeof errors === 'object' ) {
					return;
				}

				if ( errors === false ) {
					this.localError = 'Required';

					return;
				}

				this.localError = errors;
			}
		},

		formValue : {
			deep : true,
			handler( formValue ) {
				if ( this.options.computedValue && this.shouldBeComputed ) {
					this.localValue = this.options.computedValue( formValue );
				}
			}
		},

		focusFromParent : {
			immediate : true,
			handler( focus ) {

				if ( !focus ) {
					return;
				}

				this.focus = true;


				this.$nextTick( () => {
					this.focusInput();
				} );

			}
		}
	},

	methods : {

		init() {
			Promise.resolve()
				.then( () => this.options.prefill() )
				.then( ( val ) => {
					this.localValue = val;
					this.state      = 'loaded';
				} )
				.catch( () => {
					this.localError = 'Couldn\'t Prefill';
					this.localValue = this.value;
					this.state      = 'failed';
				} );
		},

		focusInput() {
			this.$refs.input.focus();
		},

		focusAndSelectIfNecessary() {
			this.focus = true;

			if ( this.options.selectOnFocus ) {
				this.$refs.input.select();
			}
		}

	}
};
</script>

<style lang='scss'>
.short-text {
	display: flex;
	align-items: center;
	padding: 15px !important;
	position: relative;

	&.accent {

		.label {
			color: $color-primary;
		}
	}

	&.has-sub-title {

		&.focus,
		&:not(.has-value) {

			.minimal-label {
				opacity: 0;
				pointer-events: none;
			}

			.sub-title {
				opacity: 1;
			}

			.input-wrapper {
				transform: translate3d(0,-8px,0);
			}
		}

		&:not(.focus).has-value,
		&.error {

			.sub-title {
				transform: translate3d(0, calc(-100% - 5px), 0);
				opacity: 0;
			}
		}

		.input-wrapper {
			transform: translate3d(0,-8px,0);
		}

		.sub-title {
			opacity: 1;
			transform: translate3d(0,-100%,0);
			pointer-events: none;
		}
	}

	&:not(.has-sub-title),
	&.has-sub-title:not(.focus) {

		.minimal-label {

			&.visible {
				transform: translate3d(0,-7px,0);
				opacity: 1;

				+ .input-wrapper {
					transform: translate3d(0, 6px, 0);
				}
			}
		}
	}

	.minimal-label,
	.sub-title {
		position: absolute;
		font-size: 12px;
		left: 15px;
		opacity: 0;
		transform: translate3d(0,0,0);
		transition: transform 0.2s ease, opacity 0.2s ease;
	}

	.minimal-label {
		top: 15px;
		color: $color-primary;

		+ .input-wrapper * {
			color: $input-color;
		}
	}

	.sub-title {
		color: $input-color-faded;
		top: calc(100% - 9px);
	}

	.error {
		color: $error;
	}

	.label,
	.label span.error {
		transition: transform 0.2s ease, opacity 0.2s ease;
	}

	.label {
		color: $input-color;

		span.error {
			position: absolute;
			bottom: 0;
			left: 0;
			transform: translate3d(0,0,0);
			opacity: 0;
			font-size: 12px;
		}

		&.error {
			transform: translate3d(0,-7px, 0);

			span.error {
				opacity: 0.8;
				transform: translate3d(0,12px,0);
			}
		}

		~ .input-wrapper * {
			color: $color-primary;
			text-align: right;
		}
	}

	.input-wrapper {
		transition: transform 0.2s ease;
		align-self: stretch;
		flex: 1 1 0;
		min-height: 25px;
		display: flex;

		input {
			background: transparent;
			color: $color-primary;
			font-size: 16px;
			min-width: 0;
			width: 0;
			flex: 1 1 0;
			font-weight: 500;
			-webkit-font-smoothing: auto;
		}

		.load-icon {
			font-weight: 600;
			position: absolute;
			right: 5px;
			top: 50%;
			transform: translateY(-50%);
			color: inherit;
			cursor: pointer;

			svg {
				height: 16px;
				width: 16px;
				fill: $error;
			}
		}
	}
}
</style>
